import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

const SomaRadioButton = (props) => {
    const { aria_label, name, value, onChange, options } = props
    return (
        <RadioGroup aria-label={aria_label} name={name} value={value} onChange={onChange}>
            {options?.map(o => {
                return (
                    <FormControlLabel
                        sx={{
                            '& .MuiFormControlLabel-label': { fontFamily: 'flama-book' }
                        }}
                        key={o.key}
                        value={o.value}
                        control={<Radio style={{ padding: '0 9px' }} />}
                        label={o.label}
                    />
                )
            })}
        </RadioGroup>
    )
}

export default SomaRadioButton